<template>
  <div class="page_article_block col-12">
    <div class="col-12">
      <div class="page_title">
        說明會場次
      </div>
    </div>
    <div class="d-none d-sm-flex seminar_area row">
      <div class="col-4 seminae_select_date_block">
        <div class="title_block">
          選擇日期
        </div>
        <div class="seminae_content_block">
          <ul class="content_list">
            <li
              v-for="orientation in orientations"
              :key="orientation.orientation_date_id"
              class="content_item clearfix"
              :class="{
                active: activeDate === orientation.orientation_date,
                'has-space': orientation.orientation_date_has_space,
                'no-space': !orientation.orientation_date_has_space
              }"
              @click="updateActiveDate(orientation.orientation_date, $event)"
            >
              <div class="circle float-left mr-3" />
              <div class="date float-left mr-5">
                {{ orientation.orientation_date || new Date() | moment('MM/DD(ddd)') }}
              </div>
              <div class="text float-left">
                {{ orientation.orientation_date_has_space | hasSpace }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-8 seminae_date_block">
        <div class="title_block date">
          {{ activeDate || new Date() | moment('YYYY/MM/DD(ddd)') }}
        </div>
        <div class="seminae_content_block">
          <table-wrapper>
            <table-row>
              <table-heading :cols="3">
                時間
              </table-heading>
              <table-heading :cols="3">
                公司統編
              </table-heading>
              <table-heading :cols="6">
                公司名稱
              </table-heading>
            </table-row>
            <table-row
              v-for="(time, index) in times"
              :key="`${time.duration}-${index}`"
            >
              <template v-if="time.enterprise_gui_number">
                <table-data :cols="3">
                  {{ time.duration }}
                </table-data>
                <table-data :cols="3">
                  {{ time.enterprise_gui_number }}
                </table-data>
                <table-data :cols="6">
                  {{ time.enterprise_name }}
                </table-data>
              </template>
              <template v-else>
                <table-data :cols="3">
                  {{ time.duration }}
                </table-data>
                <table-data :cols="9">
                  <button-wrapper
                    v-if="!readOnly"
                    fill
                    @click="enrollHostingRecruitmentOrientation(time, $event)"
                  >
                    目前空缺，按此選擇本場次
                  </button-wrapper>
                </table-data>
              </template>
            </table-row>
          </table-wrapper>
        </div>
      </div>
    </div>
    <div class="d-sm-none seminar_area select_box row">
      <div class="col-12">
        <div class="seminae_content_block d-flex justify-content-between align-items-center py-1">
          <ul class="content_list">
            <li
              v-for="orientation in orientations"
              :key="orientation.orientation_date_id"
              class="content_item clearfix d-none"
              :class="{
                active: activeDate === orientation.orientation_date,
                'has-space': orientation.orientation_date_has_space,
                'no-space': !orientation.orientation_date_has_space,
                'd-block': activeDate === orientation.orientation_date,
              }"
              @click="updateActiveDate(orientation.orientation_date, $event)"
            >
              <div class="circle float-left mr-3" />
              <div class="date float-left mr-2">
                {{ orientation.orientation_date || new Date() | moment('MM/DD(ddd)') }}
              </div>
              <div class="text float-left">
                {{ orientation.orientation_date_has_space | hasSpace }}
              </div>
            </li>
          </ul>
          <button id="select-button" class="btn-arrow-up" @click="changeArrow"></button>
        </div>
      </div>
    </div>
    <div class="d-sm-none seminar_area seminar_area_select row">
      <div class="col-12">
        <div class="seminae_content_block">
          <ul class="content_list">
            <li
              v-for="orientation in orientations"
              :key="orientation.orientation_date_id"
              class="content_item clearfix"
              :class="{
                active: activeDate === orientation.orientation_date,
                'has-space': orientation.orientation_date_has_space,
                'no-space': !orientation.orientation_date_has_space
              }"
              @click="updateActiveDate(orientation.orientation_date, $event)"
            >
              <div class="circle float-left mr-3" />
              <div class="date float-left mr-3">
                {{ orientation.orientation_date || new Date() | moment('MM/DD(ddd)') }}
              </div>
              <div class="text float-left">
                {{ orientation.orientation_date_has_space | hasSpace }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="d-sm-none seminar_area row">
      <div class="seminae_date_block col-12">
        <div class="title_block date">
          {{ activeDate || new Date() | moment('YYYY/MM/DD(ddd)') }}
        </div>
        <div class="seminae_content_block">
          <table-wrapper
            v-for="(time, index) in times"
            :key="`${time.duration}-${index}`"
          >
            <table-row class="row-time">
              <template>
                <table-data :cols="4">
                  時間
                </table-data>
                <table-data :cols="8">
                  {{ time.duration }}
                </table-data>
              </template>                
            </table-row>
            <table-row v-if="time.enterprise_gui_number">
              <template>
                <table-data :cols="4">
                  公司統編
                </table-data>
                <table-data :cols="8">
                  {{ time.enterprise_gui_number }}
                </table-data>
              </template>                
            </table-row>
            <table-row v-if="time.enterprise_gui_number">
              <template>
                <table-data :cols="4">
                  公司名稱
                </table-data>
                <table-data :cols="8">
                  {{ time.enterprise_name }}
                </table-data>
              </template>                
            </table-row>
            <!-- <table-row
            >
              <template v-if="time.enterprise_gui_number">
                <table-data :cols="3">
                  {{ time.duration }}
                </table-data>
                <table-data :cols="3">
                  {{ time.enterprise_gui_number }}
                </table-data>
                <table-data :cols="6">
                  {{ time.enterprise_name }}
                </table-data>
              </template>
              <template v-else>
                <table-data :cols="3">
                  {{ time.duration }}
                </table-data>
                <table-data :cols="9">
                  <button-wrapper
                    v-if="!readOnly"
                    fill
                    @click="enrollHostingRecruitmentOrientation(time, $event)"
                  >
                    目前空缺，按此選擇本場次
                  </button-wrapper>
                </table-data>
              </template>
            </table-row> -->
          </table-wrapper>
        </div>
      </div>
    </div>
    <enterprise-enroll-recruitment-orientation-modal
      v-if="isOpenEnrollModal"
      modal-title="確認報名該場次？"
      :is-modal-open="isOpenEnrollModal"
      :orientation-time-slot="activeTimeSlot"
      @modal:close="closeEnrollModal"
      @submit="submitEnrollment"
    />
    <redirect-login-page-modal
      v-if="isOpenRedirectModal"
      auth-type="enterprise"
      :is-modal-open="isOpenRedirectModal"
      @modal:close="closeRedirectModal"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TableWrapper from '~components/common/tables'
import TableRow from '~components/common/tables/Row'
import TableHeading from '~components/common/tables/Heading'
import TableData from '~components/common/tables/Data'
import ButtonWrapper from '~components/common/buttons'
import EnterpriseEnrollRecruitmentOrientationModal from '~components/common/modal/EnterpriseEnrollRecruitmentOrientation'
import RedirectLoginPageModal from '~components/common/modal/RedirectLoginPage'

export default {
  name: 'RecruitmentOrientationTimeSlots',
  filters: {
    hasSpace (value) {
      return value ? '尚有名額' : '場次已滿'
    }
  },
  components: {
    TableWrapper,
    TableRow,
    TableHeading,
    TableData,
    ButtonWrapper,
    EnterpriseEnrollRecruitmentOrientationModal,
    RedirectLoginPageModal
  },
  props: {
    orientations: {
      type: Array,
      default: () => []
    },
    readOnly: Boolean
  },
  data () {
    return {
      arrow: 'up',
      activeDate: '',
      isOpenEnrollModal: false,
      isOpenRedirectModal: false,
      activeTimeSlot: {}
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isEnterpriseGetter',
      'isStudentGetter'
    ]),
    dates () {
      if (!this.orientations.length) {
        return []
      }
      const dates = this.orientations.map(date => date.orientation_date)
      return dates
    },
    times () {
      if (!this.orientations.length) {
        return []
      }
      const availableDate = this.orientations.find(date => date.orientation_date === this.activeDate)
      const availableTimes = availableDate && Object.keys(availableDate).length ? availableDate.orientation_time_slots : []
      if (!availableTimes) {
        return []
      }
      return availableTimes.map((slot) => {
        return {
          orientation_date: this.activeDate,
          orientation_time_slot_id: slot.orientation_time_slot_id,
          orientation_start_time: slot.orientation_start_time,
          orientation_end_time: slot.orientation_end_time,
          duration: `${this.$moment(`${this.activeDate} ${slot.orientation_start_time}`).format('HH:mm')}~${this.$moment(`${this.activeDate} ${slot.orientation_end_time}`).format('HH:mm')}`,
          enterprise_gui_number: slot.enterprise_gui_number,
          enterprise_name: slot.enterprise_name
        }
      })
    }
  },
  watch: {
    orientations (value) {
      this.activeDate = value[0].orientation_date
    }
  },
  created () {
    this.activeDate = this.dates[0]
  },
  methods: {
    ...mapActions('layouts', [
      'toggleModal'
    ]),
    changeArrow() {
      if (this.arrow == 'up') {
        this.arrow = 'down'
      } else {
        this.arrow = 'up'
      }
      document.getElementById('select-button').className = 'btn-arrow-' + this.arrow
      if (this.arrow == 'down') {
        document.getElementsByClassName('seminar_area_select')[0].style.height = '0px'
      } else {
        document.getElementsByClassName('seminar_area_select')[0].style.height = 'auto'
      }
    },
    updateActiveDate (date) {
      this.activeDate = date
      this.changeArrow()
    },
    enrollHostingRecruitmentOrientation (time) {
      if (!this.isEnterpriseGetter) {
        this.isOpenRedirectModal = true
      } else {
        this.isOpenEnrollModal = true
        this.activeTimeSlot = time
      }

      this.toggleModal(true)
    },
    closeEnrollModal () {
      this.isOpenEnrollModal = false
      this.toggleModal(false)
    },
    closeRedirectModal () {
      this.isOpenRedirectModal = false
      this.toggleModal(false)
    },
    submitEnrollment () {
      this.$emit('submit', this.activeTimeSlot)
      this.isOpenEnrollModal = false
      this.toggleModal(false)
    }
  }
}

</script>
<style lang="scss" scoped>
.content_item {
  border-bottom: 1px solid $gray-400;
  border-top: 0.5px solid transparent;

  .circle {
    background-color: $gray-400;
  }

  &.no-space {
    .text {
      color: $danger;
    }
  }

  &.has-space {
    .circle {
      background-color:  $info;
    }
  }
  &.active {
    border-bottom: 2px solid $primary-lighten;
    border-top: 0;
    .circle {
      background-color: $primary-lighten;
    }
    .date {
      color: $primary-lighten;
    }
  }
}
.table_wrapper:not(:first-child) {
  .row-time {
    .td {
      border-top: 2px solid #00A0E9;
    }
  }
}
</style>
